/*
This function prevent to write common reducers like

switch(action.type) {
  case 'something/ACTION': {
    ...
  }
}

for this

something/ACTION: (state, { prop1, prop2 }) => {

}

or

['something/ActionName']: (state, { prop1, prop2 }) => {

}
*/
import { injectReducer } from 'redux-store/store';

export function createReducer<T, A extends { type: string, payload?: any }>(
  name: string,
  initialState: T,
  reducerMap: {
    [x in A['type']]: (b: T, a: Extract<A, { type: x }>['payload']) => T
  }
) {
  const reducer = (state: T = initialState, action: A) => {
    if (reducerMap[action.type]) {
      return reducerMap[action.type](state, action.payload);
    }

    // this is the "default" case inside a normal reducer "switch case"
    return state;
  };

  injectReducer(name, reducer);

  return reducer;
}
